import {createAction, props} from '@ngrx/store';

export enum ToastActionTypes {
  showSuccessToast = '[Toaster] show success',
  showErrorToast = '[Toaster] show error',
}

export const ShowSuccessToast = createAction(
  ToastActionTypes.showSuccessToast,
    props<{ message: string }>()
);

export const ShowErrorToast = createAction(
  ToastActionTypes.showErrorToast,
    props<{ message: string }>()
);



